/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import DevelopmentTable from './tables/DevelopmentTable';
import './diseaseProtocol.css';
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import {
  AddIcon,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  Textarea,
  Select as ChakraSelect,
} from '@chakra-ui/icons';
import { useForm } from 'react-hook-form';
// import AddDiseaseProtocol from './addDiseaseProtocol';

const Index = () => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      axisName: '',
      axisCode: '',
      weightPriority: '',
      defaultElectricity: '',
      defaultPolarity: '',
      note: '',
    },
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [axisData, setAxisData] = useState([
    {
      _id: 1,
      axisName: 'Digestive',
      axisCode: 'DIG',
      weightPriority: 1,
      defaultElectricity: 'YE',
      defaultPolarity: '-',
      note: 'Primary metabolic and eliminative axis',
    },
    {
      _id: 2,
      axisName: 'Hepatic',
      axisCode: 'HEP',
      weightPriority: 2,
      defaultElectricity: 'YE',
      defaultPolarity: '±',
      note: 'Bile & liver function — linked to DIG',
    },
    {
      _id: 3,
      axisName: 'Nerve',
      axisCode: 'NRV',
      weightPriority: 3,
      defaultElectricity: 'GE',
      defaultPolarity: '+',
      note: 'Neuro-regulatory axis — mucosa-nerve links',
    },
    {
      _id: 4,
      axisName: 'Cardio',
      axisCode: 'CAR',
      weightPriority: 4,
      defaultElectricity: 'RE',
      defaultPolarity: '±',
      note: 'Circulation and heart function',
    },
    {
      _id: 5,
      axisName: 'Respiratory',
      axisCode: 'RES',
      weightPriority: 5,
      defaultElectricity: 'GE',
      defaultPolarity: '+',
      note: 'Airway and mucosal function',
    },
    {
      _id: 6,
      axisName: 'Musculo',
      axisCode: 'MUS',
      weightPriority: 6,
      defaultElectricity: 'RE',
      defaultPolarity: '+',
      note: 'Musculoskeletal tone & mobility',
    },
    {
      _id: 7,
      axisName: 'Renal',
      axisCode: 'REN',
      weightPriority: 7,
      defaultElectricity: 'YE',
      defaultPolarity: '-',
      note: 'Filtration and fluid balance',
    },
    {
      _id: 8,
      axisName: 'Lymph',
      axisCode: 'LYM',
      weightPriority: 8,
      defaultElectricity: 'RE',
      defaultPolarity: '+',
      note: 'Detoxification and eliminative channels',
    },
    {
      _id: 9,
      axisName: 'Blood',
      axisCode: 'BLO',
      weightPriority: 9,
      defaultElectricity: 'RE',
      defaultPolarity: '±',
      note: 'Haemodynamics and deep tissue nourishment',
    },
    {
      _id: 10,
      axisName: 'Endocrine',
      axisCode: 'END',
      weightPriority: 10,
      defaultElectricity: 'GE',
      defaultPolarity: '±',
      note: 'Hormonal & metabolic control',
    },
    {
      _id: 11,
      axisName: 'Reproductive',
      axisCode: 'REP',
      weightPriority: 11,
      defaultElectricity: 'GE',
      defaultPolarity: '±',
      note: 'Glandular & reproductive function',
    },
    {
      _id: 12,
      axisName: 'Skin',
      axisCode: 'SKN',
      weightPriority: 12,
      defaultElectricity: 'BE',
      defaultPolarity: '±',
      note: 'Surface elimination & dermal reactivity',
    },
    {
      _id: 13,
      axisName: 'General',
      axisCode: 'GEN',
      weightPriority: 13,
      defaultElectricity: 'WE',
      defaultPolarity: '±',
      note: 'Overall vitality; fallback axis',
    },
  ]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState('');

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();

  const handlePageChange = (newPage) => {
    setPage(newPage);
    const newParams = new URLSearchParams(searchParams);
    newParams.set('page', newPage);
    setSearchParams(newParams);
  };

  // 🚀 Submit handler
  const onSubmit = (data) => {
    const payload = { ...data };
    console.log();
  };

  const handleBack = () => {
    reset();
    setEditId('');
    setShowForm(false);
  };
  return (
    <div style={{ marginTop: '90px' }}>
      {!showForm && (
        <DevelopmentTable
          tableData={axisData}
          handleDeleteUser={() => {}}
          onEdit={(doc) => {
            console.log('EDIT ID:', doc);
            setShowForm(true);
            setEditId(doc?._id);
            setValue('axisName', doc?.axisName);
            setValue('axisCode', doc?.axisCode);
            setValue('defaultElectricity', doc?.defaultElectricity);
            setValue('defaultPolarity', doc?.defaultPolarity);
            setValue('note', doc?.note);
            setValue('weightPriority', doc?.weightPriority);
          }}
          handlePageChange={handlePageChange}
          page={page}
          totalPages={totalPages}
          topActionButton={{
            label: 'Add System Axis Weight',
            title: 'System Axis Weight',
            icon: <AddIcon />,
            onClick: () => {
              setShowForm(true);
            },
          }}
        />
      )}
      {showForm && (
        <div style={{ marginTop: '100px' }}>
          <div className="titleWrapper">
            <h2>
              {editId !== ''
                ? 'Update System Axis Weight'
                : 'Add System Axis Weight'}
            </h2>
            <Button size="sm" colorScheme="blue" onClick={handleBack}>
              Back
            </Button>
          </div>

          {/* FORM */}

          <div style={{ marginTop: '20px' }} className="formWrapper">
            {/* Axis Name */}
            <FormControl mb={4} isInvalid={errors.axisName} isRequired>
              <FormLabel>Axis / System Name</FormLabel>
              <Input
                placeholder="Enter axis name"
                {...register('axisName', {
                  required: 'Axis name is required',
                  minLength: {
                    value: 2,
                    message: 'Minimum 2 characters',
                  },
                })}
              />
              <FormErrorMessage>{errors.axisName?.message}</FormErrorMessage>
            </FormControl>

            {/* Axis Code */}
            <FormControl mb={4} isInvalid={errors.axisCode} isRequired>
              <FormLabel>Axis Code</FormLabel>
              <Input
                placeholder="DIG, HEP, NRV..."
                {...register('axisCode', {
                  required: 'Axis code is required',
                })}
              />
              <FormErrorMessage>{errors.axisCode?.message}</FormErrorMessage>
            </FormControl>

            {/* Weight Priority */}
            <FormControl mb={4} isInvalid={errors.weightPriority} isRequired>
              <FormLabel>Weight Priority</FormLabel>
              <Input
                type="number"
                placeholder="1–13"
                {...register('weightPriority', {
                  required: 'Weight priority is required',
                  min: { value: 1, message: 'Min value is 1' },
                  max: { value: 13, message: 'Max value is 13' },
                })}
              />
              <FormErrorMessage>
                {errors.weightPriority?.message}
              </FormErrorMessage>
            </FormControl>

            {/* Default Electricity */}
            <FormControl
              mb={4}
              isInvalid={errors.defaultElectricity}
              isRequired
            >
              <FormLabel>Default Electricity</FormLabel>
              <ChakraSelect
                placeholder="Select electricity"
                {...register('defaultElectricity', {
                  required: 'Default electricity is required',
                })}
              >
                <option value="YE">YE</option>
                <option value="GE">GE</option>
                <option value="RE">RE</option>
                <option value="BE">BE</option>
                <option value="WE">WE</option>
              </ChakraSelect>
              <FormErrorMessage>
                {errors.defaultElectricity?.message}
              </FormErrorMessage>
            </FormControl>

            {/* Default Polarity */}
            <FormControl mb={4} isInvalid={errors.defaultPolarity} isRequired>
              <FormLabel>Default Polarity</FormLabel>
              <ChakraSelect
                placeholder="Select polarity"
                {...register('defaultPolarity', {
                  required: 'Default polarity is required',
                })}
              >
                <option value="-">-</option>
                <option value="+">+</option>
                <option value="±">±</option>
              </ChakraSelect>
              <FormErrorMessage>
                {errors.defaultPolarity?.message}
              </FormErrorMessage>
            </FormControl>

            {/* Note */}
            <FormControl mb={4} isInvalid={errors.note}>
              <FormLabel>Note</FormLabel>
              <Textarea
                placeholder="Enter note/description"
                {...register('note')}
              />
            </FormControl>
          </div>

          {/* Submit */}
          <div className="submitBtnWrapper">
            <Button colorScheme="teal" onClick={handleSubmit(onSubmit)}>
              {editId !== '' ? 'Update' : 'Submit'}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
